/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWhoWeAreBannerViewProps } from './who-we-are-banner';

export default (props: IWhoWeAreBannerViewProps) => {
    return (
        <main className='CmsPage'>
            <div className='CmsPage-Wrapper CmsPage-Wrapper_page_width_default'>
                <div className='CmsPage-Content'>
                    <div data-content-type='row' data-appearance='contained' data-element='main'>
                        <div
                            className='WhoWeAre'
                            data-enable-parallax='0'
                            data-parallax-speed='0.5'
                            data-background-images='{ }'
                            data-background-type='image'
                            data-video-loop='true'
                            data-video-play-only-visible='true'
                            data-video-lazy-load='true'
                            data-video-fallback-src=''
                            data-element='inner'
                            style={{
                                justifyContent: 'flex-start',
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundPosition: 'left top',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundAttachment: 'scroll',
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderRadius: '0px',
                                margin: '0px 0px 10px',
                                padding: '25px 20px'
                            }}
                        >
                            <div
                                className='Heading'
                                data-content-type='text'
                                data-appearance='default'
                                data-element='main'
                                style={{
                                    borderStyle: 'none',
                                    borderWidth: '1px',
                                    borderRadius: '0px',
                                    margin: '0px',
                                    padding: '0px'
                                }}
                            >
                                <h1 style={{ textAlign: 'center', lineHeight: '1' }}>
                                    <span style={{ fontSize: '36px', color: 'rgb(87, 87, 87)' }}>
                                        <strong>
                                            <a href={props.config.titleLink?.destinationUrl} className=' '>
                                                {props.config.title}
                                            </a>
                                        </strong>
                                    </span>
                                </h1>
                                <h3 style={{ textAlign: 'center', lineHeight: '1' }}>
                                    <span style={{ fontSize: '24px', color: 'rgb(87, 87, 87)' }}>
                                        <a href={props.config.subtitleLink?.destinationUrl} className=' '>
                                            {props.config.subtitle}
                                        </a>
                                    </span>
                                </h3>
                            </div>
                            <div
                                className='pagebuilder-column-group'
                                data-content-type='column-group'
                                data-grid-size='3'
                                data-element='main'
                                style={{ display: 'flex' }}
                            >
                                {/* Repeat this pattern for each column */}
                                {props.config.bannerCard?.map((card, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className='pagebuilder-column'
                                            data-content-type='column'
                                            data-appearance='full-height'
                                            data-background-images='{ }'
                                            data-element='main'
                                            style={{
                                                justifyContent: 'flex-start',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                backgroundPosition: 'left top',
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundAttachment: 'scroll',
                                                borderStyle: 'none',
                                                borderWidth: '1px',
                                                borderRadius: '0px',
                                                width: '33.3333%',
                                                margin: '0px',
                                                padding: '10px',
                                                alignSelf: 'stretch'
                                            }}
                                        >
                                            <div
                                                className='Icon'
                                                data-content-type='text'
                                                data-appearance='default'
                                                data-element='main'
                                                style={{
                                                    borderStyle: 'none',
                                                    borderWidth: '1px',
                                                    borderRadius: '0px',
                                                    margin: '0px',
                                                    padding: '0px'
                                                }}
                                            >
                                                <p>
                                                    <a href={card.link?.destinationUrl} className=' '>
                                                        <img
                                                            src={card.image?.src}
                                                            alt={card.image?.altText}
                                                            width='65'
                                                            height='65'
                                                            style={{
                                                                display: 'block',
                                                                marginLeft: 'auto',
                                                                marginRight: 'auto'
                                                            }}
                                                        />
                                                    </a>
                                                </p>
                                            </div>
                                            <div
                                                className='Title'
                                                data-content-type='text'
                                                data-appearance='default'
                                                data-element='main'
                                                style={{
                                                    borderStyle: 'none',
                                                    borderWidth: '1px',
                                                    borderRadius: '0px',
                                                    margin: '0px',
                                                    padding: '0px'
                                                }}
                                            >
                                                <p style={{ textAlign: 'center' }}>
                                                    <a href={card.link?.destinationUrl} className=' '>
                                                        <span style={{ fontSize: '18px' }}>{card.title}</span>
                                                    </a>
                                                </p>
                                            </div>
                                            <div
                                                className='Text'
                                                data-content-type='text'
                                                data-appearance='default'
                                                data-element='main'
                                                style={{
                                                    borderStyle: 'none',
                                                    borderWidth: '1px',
                                                    borderRadius: '0px',
                                                    margin: '0px',
                                                    padding: '0px'
                                                }}
                                            >
                                                <p style={{ textAlign: 'center' }}>
                                                    <a href='' className=' '>
                                                        {card.description}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};
